import cx from 'classnames';
import { FC, ReactElement } from 'react';

import CloseIcon from '../../SVGIcons/CloseIcon';
import classes from './Tag.module.scss';
import { TagProps } from './Tag.types';

export const Tag: FC<TagProps> = ({
  className,
  variantBG = 'default',
  fontWeight = 'regular',
  variantColor = 'black',
  onClose,
  children,
}): ReactElement => (
  <div
    className={cx(
      classes.tag,
      classes[`tag--bg-${variantBG}`],
      classes[`tag--color-${variantColor}`],
      classes[`tag--font-weight-${fontWeight}`],
      className,
    )}
  >
    {children}
    {onClose && (
      <CloseIcon
        role="none"
        className={classes['tag__close-icon']}
        onClick={onClose}
        fill="black"
      />
    )}
  </div>
);
